import { z } from "zod/v4";

import {
  SubscriptionBillingProviderList,
  SubscriptionIntervalList,
  SubscriptionWithScopesDtoSchema,
} from "./subscriptions";

export const SubscriptionStatusList = [
  "active",
  "pending",
  "cancelled",
] as const;
export type SubscriptionStatus = (typeof SubscriptionStatusList)[number];

export const StripeSubscriptionStatusList = [
  "active",
  "canceled",
  "cancelled",
  "pending",
  "incomplete",
  "incomplete_expired",
  "past_due",
  "paused",
  "trialing",
  "unpaid",
] as const;

export type StripeSubscriptionStatus =
  (typeof StripeSubscriptionStatusList)[number];

export const OrganizationSubscriptionDtoSchema = z.object({
  id: z.uuid(),
  subscriptionId: z.uuid(),
  organizationId: z.uuid(),
  subscriptionPriceUsd: z.number(),
  subscriptionStatus: z.enum(SubscriptionStatusList),
  subscriptionInterval: z.enum(SubscriptionIntervalList),
  intervalCount: z.number().default(1),
  subscription: SubscriptionWithScopesDtoSchema,
  billingProvider: z.enum(SubscriptionBillingProviderList),
});

export type OrganizationSubscriptionDto = z.infer<
  typeof OrganizationSubscriptionDtoSchema
>;
